import {findAll} from "../../../../../modules/vegas/js/util";
import VGModal from "./modal";

function onReady() {
	let $btnModal = findAll('[data-vg-toggle="modal"], [data-bs-toggle="modal"]');
	if ($btnModal.length) {
		for (let $btn of $btnModal) {
			$btn.onclick = function () {
				VGModal.init(this);
				return false;
			};
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);
